<!-- Page Wrapper -->
<div [ngClass]="{ 'page-wrapper porletHeight': Portlet === 'half' }">
  <div [ngClass]="{ 'content container-fluid': Portlet === 'half' }">
    <div [ngClass]="{ 'bg-white page-border': Portlet === 'half' }">
      <!--header-->
      <div class="row row-replace add-m-b" *ngIf="Portlet == 'half'">
        <div class="col-md-6 col-9 col-p h5">
          <i class="fa fa fa-cogs"></i> Employee Attendance
        </div>
        <div class="col-md-6 col-3 top-corner-items col-p">
          <button class="btn btn-primary btn-sm" (click)="back()">
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      </div>
      <!--end header-->
      <div class="col-md-12 bg-main mt-2 pt-2">
        <form [formGroup]="attForm">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Select Year</label>
                <select2
                  [data]="attYear"
                  formControlName="year"
                  placeholder="Select Year"
                ></select2>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12">
              <div class="form-group">
                <label>Select Month</label>
                <select2
                  [data]="attMonths"
                  formControlName="month"
                  placeholder="Select Month"
                ></select2>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12">
              <label></label><br>
              <button class="btn btn-primary btn-padding1 m-2 bg-main2" type="submit" (click)="getAttendanceByClick()">
                Search
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="row tele1">
        <div class="col-md-12 mt-2 table-responsive">
          <table class="table bg-white" cellspacing="0" width="100%">
            <thead class="bg-table-header1">
              <tr>
                <th>S.No.</th>
                <th>Date</th>
                <th>Day</th>
                <th>Attendance</th>
                <th *ngFor="let item of header">{{ item }}</th>
                <th *ngIf="self == 1">Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="attData.length > 0; else noData">
                <tr *ngFor="let data of attData; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    {{ data.date }}
                    <i
                      class="fa fa-history"
                      (click)="viewHistory(data)"
                      aria-hidden="true"
                      *ngIf="data.logCount > 0"
                    ></i>
                  </td>
                  <td>{{ data.day }}</td>

                  <td>
                    <span *ngIf="data.code != ''"
                      >{{ data.code }} {{ data.lv_desc }}</span
                    >
                  </td>
                  <td *ngIf="ccObj.is_in_out1 == 1">
                    {{ data.in_time1 }}
                  </td>
                  <td *ngIf="ccObj.is_in_out1 == 1">
                    {{ data.out_time1 }}
                  </td>
                  <td *ngIf="ccObj.is_in_out2 == 1">
                    {{ data.in_time2 }}
                  </td>
                  <td *ngIf="ccObj.is_in_out2 == 1">
                    {{ data.out_time2 }}
                  </td>
                  <td *ngIf="ccObj.is_in_out3 == 1">
                    {{ data.in_time3 }}
                  </td>
                  <td *ngIf="ccObj.is_in_out3 == 1">
                    {{ data.out_time3 }}
                  </td>
                  <td>{{ data.ot_hrs }}</td>
                  <td>{{ data.ot1_hrs }}</td>
                  <td>{{ data.total_hrs_show }}</td>
                  <td *ngIf="self == 1">
                    <div
                      class="btn-group btn-group-sm"
                      *ngIf="data.can_regularise == true"
                    >
                      <button
                        class="btn-danger"
                        (click)="regularise(data)"
                      >
                        Regularize
                      </button>
                    </div>

                    <span
                      *ngIf="
                        data.can_regularise == false &&
                        data.username != '' &&
                        data.username != null
                      "
                    >
                      {{ data?.req_type || "" }}
                      <span *ngIf="data?.leave_code != ''">
                        {{ data?.leave_code || "" }}
                      </span>
                      Request pending to : {{ data.username }}-{{
                        data.name
                      }}
                      {{ data.lname }}
                      <button
                        class="btn-warning"
                        *ngIf="data?.req_type != 'Leave'"
                        (click)="withdraw(data)"
                      >
                        <i class="fa fa-undo" aria-hidden="true"></i>
                        Withdraw
                      </button>
                    </span>
                  </td>
                </tr>
              </ng-container>
              <ng-template #noData>
                <tr>
                  <td colspan="11" class="text-center">No Attendance</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
      <!-- end table  -->
      <div id="att_regularise" class="modal custom-modal fade" data-backdrop="static" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-xlg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Attendance Regularise</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <table class="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Attendance</th>
                      <th *ngFor="let item of header">{{ item }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let data of attDataRegularise; let i = index"
                    >
                      <td>{{ data.date }}</td>
                      <td
                        *ngIf="
                          data.code == '' ||
                          data.code == 'A.5' ||
                          data.code == 'P' ||
                          data.code == 'A'
                        "
                      >
                        <select
                          class="form-control"
                          [(ngModel)]="attDataRegulariseSelect"
                        >
                          <option
                            [value]="item.lv_type_id"
                            *ngFor="let item of getRegulariseAttCodeList"
                          >
                            {{ item.code }} {{ item.lv_desc }}
                          </option>
                        </select>
                      </td>
                      <td *ngIf="(data.code == 'WO' || data.code == 'H') && data.is_compoff_applicable==1">
                        <select
                          class="form-control"
                          [(ngModel)]="attDataRegulariseSelect"
                        >
                          <option
                            [value]="item.lv_type_id"
                            *ngFor="let item of getRegulariseAttCodeListCo"
                          >
                            {{ item.code }} {{ item.lv_desc }}
                          </option>
                        </select>
                      </td>
                      <td *ngIf="(data.code == 'WO' || data.code == 'H') && data.is_compoff_applicable==0">
                        <select
                          class="form-control"
                          [(ngModel)]="attDataRegulariseSelect"
                        >
                          <option
                            [value]="item.lv_type_id"
                            *ngFor="let item of getRegulariseAttCodeList"
                          >
                            {{ item.code }} {{ item.lv_desc }}
                          </option>
                        </select>
                      </td>
                      <td *ngIf="ccObj.is_in_out1 == 1">
                        <input
                          type="time"
                          class="form-control"
                          [(ngModel)]="data.in_time1"
                        />
                      </td>
                      <td *ngIf="ccObj.is_in_out1 == 1">
                        <input
                          type="time"
                          class="form-control"
                          [(ngModel)]="data.out_time1"
                        />
                      </td>
                      <td *ngIf="ccObj.is_in_out2 == 1">
                        <input
                          type="time"
                          class="form-control"
                          [(ngModel)]="data.in_time2"
                        />
                      </td>
                      <td *ngIf="ccObj.is_in_out2 == 1">
                        <input
                          type="time"
                          class="form-control"
                          [(ngModel)]="data.out_time2"
                        />
                      </td>
                      <td *ngIf="ccObj.is_in_out3 == 1">
                        <input
                          type="time"
                          class="form-control"
                          [(ngModel)]="data.in_time3"
                        />
                      </td>
                      <td *ngIf="ccObj.is_in_out3 == 1">
                        <input
                          type="time"
                          class="form-control"
                          [(ngModel)]="data.out_time3"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="data.ot_hrs"
                          readonly
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="data.ot1_hrs"
                          readonly
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="data.total_hrs_show"
                          readonly
                        />
                        <input
                        type="hidden"
                        class="form-control"
                        [(ngModel)]="data.total_hrs"
                        readonly
                      />
                      </td>
                    </tr>
                    <tr>
                      <td colspan="8">
                        <p>Remark</p>
                        <textarea
                          class="form-control"
                          [(ngModel)]="this.attDataRegularise[0].usr_remark"
                          rows="5"
                        ></textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                (click)="submitRegularise()"
                class="btn btn-primary btn-sm"
              >
                <i class="fa fa-save"></i> SAVE
              </button>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                class="btn btn-danger btn-sm"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="att_regularise_history" class="modal custom-modal fade" data-backdrop="static" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-xlg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Attendance Regularise Logs : {{ attRegulariseHistoryDate }}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="table-responsive">
                  <table class="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th *ngFor="let item of historyHeader">
                          {{ item }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of attRegulariseHistory;
                          let i = index
                        "
                      >
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.code }}</td>
                        <td *ngIf="ccObj.is_in_out1 == 1">
                          {{ item.in_time1 }}
                        </td>
                        <td *ngIf="ccObj.is_in_out1 == 1">
                          {{ item.out_time1 }}
                        </td>
                        <td *ngIf="ccObj.is_in_out2 == 1">
                          {{ item.in_time2 }}
                        </td>
                        <td *ngIf="ccObj.is_in_out2 == 1">
                          {{ item.out_time2 }}
                        </td>
                        <td *ngIf="ccObj.is_in_out3 == 1">
                          {{ item.in_time3 }}
                        </td>
                        <td *ngIf="ccObj.is_in_out3 == 1">
                          {{ item.out_time3 }}
                        </td>
                        <td>{{ item.ot_hrs }}</td>
                        <td>{{ item.ot1_hrs }}</td>
                        <td>{{ item.usr_remark }}</td>
                        <td>{{ item.requested_on }}</td>
                        <td>
                          {{ item.username }}-{{ item.name }}
                          {{ item.lname }}
                        </td>
                        <td>{{ item.approver_remark }}</td>
                        <td>{{ item.status }}</td>
                        <td>{{ item.action_date }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                class="btn btn-danger btn-sm"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end of col-->
  </div>
</div>